<template>
  <DxDataGrid class="isScrolledByGeneralFilter" :data-source="data" :show-borders="true"
    @exporting="$emit('exporting', $event)" :scrolling="{ useNative: true }"
    :column-auto-width="true">
    <DxExport :enabled="true" />
    <DxColumn data-field="FechaRegistro" caption="Fecha" data-type="date" />
    <DxColumn data-field="ID_Item" caption="Código del producto" />
    <DxColumn data-field="CodigoAlterno" caption="Código alterno" />
    <DxColumn data-field="ItemName" caption="Producto" />
    <DxColumn data-field="Familia" caption="Familia" />
    <DxColumn data-field="Categoria" caption="Categoría" />
    <DxColumn data-field="Bodega" caption="Bodega" />
    <DxColumn data-field="TotalStock" caption="Existencias" />
    <DxColumn data-field="CostoPromedio" caption="Costo unitario" />
    <DxColumn data-field="TotalCost" caption="Costo total"/>
    <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
    <DxPaging :page-size="10" />
  </DxDataGrid>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";

export default {
  name: "InventoryHistoricalCostReportTable",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxExport,
    DxPager,
    DxPaging,
  }
};
</script>
